export default __webpack_public_path__ + "static/media/BCBackgroundPage.6974a153.svg";